import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmt = (n) =>
  (n ?? 0).toLocaleString("fr-FR").replace(/,/g, "\u202f");

// Affichage en piles uniquement (à partir des unités stockées) : « 12 » ou « 12,3 » si le compte ne tombe pas juste.
// Les rebuts, casses et pertes transport restent en unités et ne passent jamais par cette conversion.
export const fmtPiles = (qty, size, long = false) => {
  const s = size || 1;
  const p = Math.round(((qty ?? 0) / s) * 10) / 10;
  const txt = p.toLocaleString("fr-FR", { maximumFractionDigits: 1 }).replace(/\u202f/g, " ");
  if (!long) return txt;
  return `${txt} ${Math.abs(p) <= 1 ? "pile" : "piles"}`;
};

const TZ = "Europe/Paris";
// Date/heure affichées en fuseau Europe/Paris.
export const fmtDateTime = (iso, opts) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return d.toLocaleString("fr-FR", { timeZone: TZ, ...(opts || { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) });
};

// Jour calendaire (AAAA-MM-JJ) affiché tel quel, sans décalage de fuseau.
export const fmtDay = (ymd, opts) => {
  if (!ymd) return "";
  const d = new Date(`${ymd}T12:00:00Z`);
  if (Number.isNaN(d.getTime())) return ymd;
  return d.toLocaleDateString("fr-FR", { timeZone: TZ, ...(opts || { weekday: "long", day: "numeric", month: "long", year: "numeric" }) });
};
